import { useSectionStates } from '@/features/kyc/hooks/useSectionStates';
import { IUser } from '@/features/user/store/user.model';
import { PhysicalMainInformation } from '@/features/kyc/components/userInformation/physicalUser/PhysicalMainInformation';
import { PhysicalVerificationDetail } from '@/features/kyc/components/userInformation/physicalUser/PhysicalVerificationDetail';
import { TPhysicalSectionKey } from '@/features/kyc/store/types/physical.types';

export interface IPhysicalUserProps {
  user: IUser;
}

export function PhysicalUser({ user }: IPhysicalUserProps) {
  const { toogleSectionEditMode, isSectionEditable, isSectionOnEdition } = useSectionStates<TPhysicalSectionKey>([
    'personalInformation',
    'address',
    'contact',
    'birthAndNationality',
    'situation',
    'taxResidence',
  ]);

  return (
    <>
      <PhysicalMainInformation
        user={user}
        isSectionOnEdition={isSectionOnEdition}
        isSectionEditable={isSectionEditable}
        toogleSectionEditMode={toogleSectionEditMode}
      />
      <PhysicalVerificationDetail
        user={user}
        isSectionOnEdition={isSectionOnEdition}
        isSectionEditable={isSectionEditable}
        toogleSectionEditMode={toogleSectionEditMode}
      />
    </>
  );
}
